import styled from "@emotion/styled";
import { MOBILE_QUERY_MAX_WIDTH } from "/constants/vp-sizes";
export const StyledComparisonFeatureComponent = styled.div`
  .table-row {
    &.even {
      background: #ecf4f8;
      border-radius: 40px;
    }

    &.big-texts {
      .table-cell:not(.first-cell) {
        font-size: 1.375rem;
      }
    }
  }

  .mobile-table-row {
    display: none;
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .table-row {
      display: none;
    }

    .mobile-table-row {
      display: block;

      .feature-title {
        display: flex;
        height: 40px;
        align-items: center;
        justify-content: center;
      }

      .feature-cells {
        display: flex;
        height: 50px;
        align-items: center;
        background: #ecf4f8;
        border-radius: 30px;
        margin: 0px 5vw;

        .table-cell {
          flex: 1 0;
        }
      }
    }
  }
`;
